import { useApplicationContext } from '../../common/containers/ApplicationContext';

export function useDownLoadAppUrl(): string {
  const { config } = useApplicationContext();

  const downLoadUrl = config.getStrict<string>('mobileBanner.browserUrl');

  return downLoadUrl;
}
